import { menu } from './core/menu/menu';
import { LayoutComponent } from './shared/layout/layout.component';
const ɵ0 = () => import("./panel/panel.module.ngfactory").then(m => m.PanelModuleNgFactory);
export const routes = [
    { path: "", redirectTo: "login", pathMatch: "full" },
    {
        path: "",
        component: LayoutComponent,
        loadChildren: ɵ0
    },
    // 404 Not found
    { path: "**", redirectTo: "not-found" }
];
export class RoutesModule {
    constructor(menuService, tr, settings) {
        this.menuService = menuService;
        this.settings = settings;
        this.settings.isLightVersion$.subscribe(lightVersion => {
            if (lightVersion)
                menuService.addMenu(menu.filter(f => f.lightVersion == lightVersion));
            else
                menuService.addMenu(menu);
        });
    }
}
export { ɵ0 };
